export default "__VITE_ASSET__di2fZPui__"